import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel, Grid, SvgIcon, Menu } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast from "react-hot-toast";
import { Link } from "@material-ui/core";
import { Button } from "@material-ui/core";
import {
  getDateTime,
  editTicketPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import http from "../services/httpService";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import SearchBar from "material-ui-search-bar";
import Filter from "../components/filerComponent";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
import staticFiles from "../services/staticApi";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { usePersistentState } from "react-persistent-state";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

function AdvicesPending(props) {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [orignalRows, setOriginalRows] = useState([]);
  const [orderBy, setOrderBy] = useState("cust__createddt");
  const [order, setOrder] = useState("asc");
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [columns, setColumns] = useState([
    {
      headerName: "ID",
      id: "reqid",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Name",
      id: "name",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "User ID",
      id: "userid",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "EFG",
      id: "efg",
      show: true,
      minWidth: 100,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Mobile Number",
      id: "mobile",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Date Of Request",
      id: "date",
      show: true,
      minWidth: 200,
      format: "Date",
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Country Of Investment",
      id: "country",
      show: true,
      minWidth: 200,
      type: "array",
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Investment Amount",
      id: "amount",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "ELSS",
      id: "elss",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Frequency Of Request",
      id: "freq",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Type",
      id: "type",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Filter Type",
      id: "filter_type",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
  ]);
  // (Boolean(anchorEl));
  // const isMenuOpen = Boolean(anchorEl);
  const location = useLocation();
  const myparam = location.state;
  const isMenuOpen = anchorEl;
  const form = {
    issue_type: [],
    ticket_created_at: "",
    ticket_created_at__condition: "lte",
    reporter: [],
    assigned: [],
    severity: [],
    status: "",
  };

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);
    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewDetails = (object) => {
    object.page = page;
    history.push({
      pathname: editTicketPath,
      state: object,
    });
  };

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");

    getAdvicesList();
    // (myparam);

    // (page);
  }, [page, rowsPerPage]);

  //Frontend pagination and search
  const getAdvicesList = (newQuery) => {
    const baseURL = "/manual_advice_sent";
    toast.loading("Please wait...");

    // .get("/ticketlist")
    // .get("/manual_advice_sent")
    http
      .get(baseURL)
      .then((response) => {
        toast.dismiss();
        if (response && response.data && response.data.Data.length > 0) {
          let finalData = [];
          let tempDta = response.data.Data;
          let tempStatusDta = tempDta.map((item, index) => {
            const swapValue = (item) => {
              Object.keys(item).forEach((key) => {
                //(Object.keys(item));
                // if (!item[key]) {
                //     item[key] = "N/A";
                // }
              });
            };
            swapValue(item);

            if (item.country.length !== 0) {
              finalData.push(item.country);
            } else {
              finalData.push(item.country);
            }
            if (item.elss === null) {
              finalData.push((item.elss = "N/A"));
            } else {
              finalData.push(item.elss);
            }
            if (item.filter_type === null) {
              finalData.push((item.filter_type = "N/A"));
            } else {
              finalData.push(item.filter_type);
            }
            return item;
          });
          setOriginalRows(tempDta);
          setRows(tempDta);
          // setTotalRowCount(response.data.totalRowCount);
          setTotalRowCount(response.data.Data.length);
        } else {
          setOriginalRows([]);
          setRows([]);
          setTotalRowCount(0);
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };
  return (
    <Paper className={classes.root}>
      <Grid container style={{ justifyContent: "space-between", margin: 10 }}>
        <Grid item xs={3}>
          <SearchBar
            value={searched}
            onChange={(searchVal) => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
            style={{ height: "unset", padding: "5px", marginTop: 5 }}
          />
        </Grid>
        <Grid container xs={5} style={{ flexWrap: "nowrap" }}>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500]}
            component="div"
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  className="prospect_table"
                >
                  {/* <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : "asc"}
                    onClick={(e) =>
                      handleRequestSort(e, column.id, column.format)
                    }
                  >
                  </TableSortLabel> */}
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length !== 0 ? (
              <>
                {rows
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index + "a"}
                        className="prospecttable"
                      >
                        {columns.map((column, index) => {
                          const text = row.comments;

                          const value = row[column.id];
                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                            >
                              {column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : column.id === "detailsButton" ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  style={{ borderRadius: 20 }}
                                  onClick={() => viewDetails(row)}
                                >
                                  View Details
                                </Button>
                              ) : column.format === "Date" ? (
                                getDateTime(value)
                              ) : column.operation &&
                                column.operation === "concate" ? (
                                value + column.operand + row[column.with]
                              ) : column.type &&
                                column.type === "link" &&
                                value ? (
                                <Link
                                  variant="body2"
                                  onClick={(e) => viewDetails(row)}
                                  gutterBottom
                                  style={{ cursor: "pointer" }}
                                >
                                  {value}
                                </Link>
                              ) : column.type &&
                                column.type === "attach" &&
                                value !== "N/A" ? (
                                <Link
                                  href={staticFiles + value}
                                  target="_blank"
                                  variant="body2"
                                  gutterBottom
                                  style={{ cursor: "pointer" }}
                                >
                                  {value}
                                </Link>
                              ) : column.type === "comments" ? (
                                <ReactReadMoreReadLess
                                  charLimit={10}
                                  readMoreText={"More ▼"}
                                  readLessText={"Less ▲"}
                                  readMoreStyle={{
                                    color: "#2835d5",
                                    cursor: "pointer",
                                  }}
                                  readLessStyle={{
                                    color: "#2835d5",
                                    cursor: "pointer",
                                  }}
                                >
                                  {!value ? "N/A" : value}
                                </ReactReadMoreReadLess>
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </>
            ) : (
              <TableCell
                colspan="9"
                style={{ "text-align": "center", margin: "10px 0px" }}
              >
                Records Not Available
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
export default AdvicesPending;
